<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>结算中心</el-breadcrumb-item>
        <el-breadcrumb-item>银行卡管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px">
        <el-form-item label="银行卡：" prop="bankcard">
          <div style="display: flex; flex-wrap: wrap" v-if="bankcardList.length > 0">
            <div class="bankcard-box mgl10 mgt10" v-for="(item, index) in bankcardList" :key="index">
              <p>{{ item.bankName }}</p>
              <p>{{ item.bankcard | formatBankcard }}</p>
              <div style="position: relative">
                <el-button @click="editItem(item, index)" type="text" style="position: absolute; top: 0; left: 10px"> 修改 </el-button>

                <confirm-button type="text" style="position: absolute; top: 0; right: 10px" title="确认要删除该条数据？" @confirmed="deleteItem(item.id)">
                  <span>删除</span>
                </confirm-button>
              </div>
            </div>
          </div>

          <div v-if="bankcardStatus" class="add-dashed-btn mgt10 mgl10" @click="openBankcardBox">
            <i class="el-icon-plus"></i>
            <span>添加银行卡</span>
          </div>
          <div class="add-bankcard-box mgt10 mgl10" v-if="bankListVisible === true" v-loading="bankcardBoxLoading">
            <el-form ref="bankcardListForm" :model="listParams.bankcardListParams" :rules="checkBankcardListParams" label-width="100px">
              <el-form-item label="开户单位：" prop="accountOpener">
                <el-input size="small" placeholder="请输入开户单位" v-model.trim="listParams.bankcardListParams.accountOpener"> </el-input>
              </el-form-item>

              <el-form-item class="mgt15" label="银行：" prop="bankId">
                <el-select
                  style="width: 100%"
                  size="small"
                  placeholder="请查询并选择银行"
                  filterable
                  remote
                  :loading="bankLoading"
                  :remote-method="remoteMethod"
                  @change="clearBankList"
                  v-model="listParams.bankcardListParams.bankId"
                >
                  <el-option v-for="item in bankList" :key="item.id" :value="item.id" :label="item.title"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="mgt15" label="开户城市：">
                <div style="display: flex">
                  <el-form-item prop="cityOpener.province">
                    <el-select style="width: 120px" size="small" placeholder="省" @change="loadCityList" v-model="listParams.bankcardListParams.cityOpener.province">
                      <el-option v-for="item in provinceList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item prop="cityOpener.city">
                    <el-select style="width: 120px; margin-left: 10px" size="small" placeholder="市" v-model="listParams.bankcardListParams.cityOpener.city">
                      <el-option v-for="item in cityList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item class="mgt15" label="开户网点：" prop="branchOpener">
                <el-input size="small" placeholder="请输入开户网点" v-model.trim="listParams.bankcardListParams.branchOpener"> </el-input>
              </el-form-item>

              <el-form-item class="mgt15" label="银行卡号：" prop="bankcard">
                <el-input :maxlength="23" size="small" placeholder="请输入银行卡号" v-model.trim="listParams.bankcardListParams.bankcard"> </el-input>
              </el-form-item>

              <el-form-item label=" " class="mgt15">
                <el-button style="width: 120px" size="small" @click="closeAndResetForm('bankcardListForm')"> 取 消 </el-button>

                <el-button :disabled="bankBtnDisabled" style="width: 120px" size="small" type="primary" @click="saveBankcard('bankcardListForm')">
                  <span v-if="bankcardStatus">添 加</span>
                  <span v-else>修 改</span>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const checkIsNum = function (rule, value, callback) {
      if (value) {
        if (!/^[\d\s]+$/.test(value)) {
          callback(new Error("银行卡格式错误"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入银行卡号"));
      }
    };
    return {
      listParams: {
        bankcardListParams: {
          accountOpener: "",
          bankId: "",
          cityOpener: {
            province: "",
            city: "",
          },
          branchOpener: "",
          bankcard: "",
          id: "",
        },
      },
      checkBankcardListParams: {
        accountOpener: [{ required: true, message: "请输入开户单位", trigger: "blur" }],
        bankId: [{ required: true, message: "请查询并选择银行", trigger: "change" }],
        "cityOpener.province": [{ required: true, message: "请选择省", trigger: "change" }],
        "cityOpener.city": [{ required: true, message: "请选择市", trigger: "change" }],
        branchOpener: [{ required: true, message: "请输入开户网点", trigger: "blur" }],
        bankcard: [{ required: true, message: "请输入银行卡号", trigger: "blur" }, { validator: checkIsNum }],
      },
      bankList: [], // 银行列表
      provinceList: [],
      cityList: [],
      bankcardList: [],
      bankBtnDisabled: false,
      bankListVisible: false,
      bankLoading: false,
      bankcardStatus: true,
      bankcardBoxLoading: false,
      copyBankName: "",
      copyBankId: "",
      copyBankcardList: [],
    };
  },
  mounted() {
    this.loadBankcardList();
    this.loadProvinceList();
  },
  methods: {
    /**
     * 初始化加载银行卡列表
     */
    loadBankcardList() {
      this.$http({
        url: global.apiUrl + "/settlement/bankcardList",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.bankcardList = res.body.data;
            this.copyBankcardList = res.body.data;
          } else {
            this.bankcardList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 打开银行卡box -- 添加状态
     */
    openBankcardBox() {
      this.bankListVisible = true;
      this.bankcardStatus = true;
    },
    /**
     * 远程查询银行
     * @param query
     */
    remoteMethod(query) {
      this.$http({
        url: global.apiUrl + "/settlement/bankList?query=" + query,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.bankList = res.body.data;
          } else {
            this.bankList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    clearBankList(val) {
      if (val) {
        this.bankList = [];
      }
    },
    /**
     * 初始化加载省份列表
     */
    loadProvinceList() {
      this.$http({
        url: global.apiUrl + "/settlement/provinceList",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.provinceList = res.body.data;
          } else {
            this.provinceList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 联动加载城市列表
     * @param query
     */
    loadCityList(query) {
      this.cityList = [];
      this.$http({
        url: global.apiUrl + "/settlement/cityList?provinceId=" + query,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.cityList = res.body.data;
          } else {
            this.cityList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 关闭并重置表单
     * @param name
     */
    closeAndResetForm(name) {
      this.bankListVisible = false;
      this.bankcardStatus = true;
      const params = this.listParams;
      for (const i in params) {
        if (typeof params[i] === "object") {
          for (const j in params[i]) {
            if (typeof params[i][j] === "object") {
              for (const k in params[i][j]) {
                params[i][j][k] = "";
              }
            } else {
              params[i][j] = "";
            }
          }
        } else {
          params[i] = "";
        }
      }
    },
    /**
     * 添加/修改银行卡
     * @param name
     */
    saveBankcard(name) {
      this.bankBtnDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          let bodyParams = {};
          let url = "";
          let method = "";
          if (this.bankcardStatus) {
            url += global.apiUrl + "/settlement/bankcard";
            method += "POST";
            bodyParams = Object.assign({}, this.listParams.bankcardListParams);
            delete bodyParams.id;
          } else {
            url += global.apiUrl + "/settlement/bankcard";
            method += "PUT";
            const params = this.listParams.bankcardListParams;
            bodyParams = Object.assign(
              {},
              {
                id: params.id,
                accountOpener: params.accountOpener,
                bankId: params.bankId,
                branchOpener: params.branchOpener,
                bankcard: params.bankcard,
              },
              {
                cityOpener: params.cityOpener,
              }
            );
            if (bodyParams.bankId === this.copyBankName) {
              bodyParams.bankId = this.copyBankId;
            }
          }
          this.$http({
            url: url,
            method: method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.closeAndResetForm("bankcardListForm");
                this.loadBankcardList();
                this.bankListVisible = false;
                this.bankBtnDisabled = false;
              } else {
                this.bankBtnDisabled = false;
              }
            })
            .catch(err => {
              this.bankBtnDisabled = false;

              console.error(err);
            });
        } else {
          this.bankBtnDisabled = false;
        }
      });
    },
    /**
     * 修改银行卡
     * @param item
     * @param index
     */
    editItem(item, index) {
      this.bankcardStatus = false;
      this.bankcardBoxLoading = true;
      this.bankListVisible = true;
      this.listParams.bankcardListParams.cityOpener.province = parseInt(item.province);
      this.loadCityList(parseInt(item.province));
      setTimeout(() => {
        this.listParams.bankcardListParams.id = item.id;
        this.listParams.bankcardListParams.accountOpener = item.accountOpener;
        this.listParams.bankcardListParams.bankId = item.bankName;
        this.copyBankName = item.bankName;
        this.copyBankId = item.bankId;
        this.listParams.bankcardListParams.cityOpener.city = parseInt(item.city);
        this.listParams.bankcardListParams.branchOpener = item.branchOpener;
        this.listParams.bankcardListParams.bankcard = this.copyBankcardList[index].bankcard;
        this.bankcardBoxLoading = false;
      }, 500);
    },
    /**
     * 删除银行卡
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/settlement/bankcard?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.closeAndResetForm("bankcardListForm");
            this.loadBankcardList();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  watch: {
    "listParams.bankcardListParams.bankcard": function (val, oldVal) {
      if (val) {
        // 输入四位自动加空格
        this.listParams.bankcardListParams.bankcard = val.replace(/[\s]/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .hx-form-container {
    .add-dashed-btn {
      width: 200px;
      height: 80px;
      border: 1px #b4bccc dashed;
      border-radius: 5px;
      color: #b4bccc;
      line-height: 80px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
    }
    .add-dashed-btn:hover {
      color: teal;
      border-color: teal;
    }
    .bankcard-list-style {
      width: 200px;
      height: 50px;
      border: 1px teal solid;
    }
    .bankcard-box {
      position: relative;
      cursor: pointer;
      width: 240px;
      height: 120px;
      border: 1px teal solid;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      .triangle-border {
        width: 0;
        height: 0;
        border-width: 30px 0 0 30px;
        border-style: solid;
        border-color: teal transparent transparent transparent;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .been-chosen {
      border: 1px teal solid;
      color: #000000;
    }
    .add-bankcard-box {
      width: 400px;
      border: 1px teal dashed;
      border-radius: 5px;
      padding: 10px 10px;
    }
  }
}
</style>
